import { ICONS } from './constants';
import { getCertificateSignatories } from '../utils/learnerCertificate';
import { formatLocalDate } from '../utils/localDateTime';

interface LearnerCertificateProps {
    studentName: string;
    courseName: string;
    completionDate: string;
    certificateId: string;
    organizationName?: string;
}

export default function LearnerCertificate({ studentName, courseName, completionDate, certificateId, organizationName }: LearnerCertificateProps) {
    const signatories = getCertificateSignatories(organizationName);

    return (
        <article aria-label="Learner certificate" className="w-full border-[12px] border-blue-900 p-2 shadow-lg">
            <div className="border-2 border-blue-200 bg-white p-4 text-center sm:p-8">
                <div role="img" aria-label="IntelOptics logo" className="mb-6 flex flex-wrap items-center justify-center gap-3 text-2xl font-bold tracking-widest text-blue-600 sm:text-3xl">
                    <span aria-hidden="true" className="shrink-0 [&>svg]:h-12 [&>svg]:w-12">{ICONS.logo}</span>
                    <span>INTELOPTICS</span>
                </div>
                <h1 className="mb-4 break-words font-serif text-3xl uppercase tracking-widest text-slate-800 md:text-5xl">Certificate of Competency</h1>
                <p className="mb-6 text-xl italic text-slate-500">This is to certify that</p>
                <h2 className="mb-6 break-words border-b-2 border-slate-300 pb-4 font-serif text-4xl text-slate-900 md:text-5xl">{studentName}</h2>
                <p className="mx-auto mb-6 max-w-2xl text-lg text-slate-600">Has successfully completed all requirements and demonstrated competency in the course:</p>
                <h3 className="mb-10 break-words text-2xl font-bold text-blue-900 md:text-3xl">{courseName}</h3>
                <div className="grid grid-cols-1 items-end gap-8 sm:grid-cols-2">
                    {signatories.map(signatory => (
                        <div key={signatory.role} className="min-w-0 text-center">
                            <p className="mb-2 break-words font-serif text-xl italic text-slate-800">{signatory.name}</p>
                            <p className="border-t border-slate-800 pt-2 text-sm uppercase tracking-wider text-slate-500">{signatory.role}</p>
                            <p className="mt-1 text-xs text-slate-500">Electronically signed</p>
                        </div>
                    ))}
                </div>
                <p className="mt-8 text-sm text-slate-600">Date of Completion: {formatLocalDate(completionDate)}</p>
                <p className="mt-4 break-words font-mono text-xs text-slate-400">ID: {certificateId}</p>
            </div>
        </article>
    );
}
